const React = require('react')
const { ContextProvider } = require('./src/components/context')
const { ErrorBoundary } = require('react-error-boundary')
const { ErrorFallback } = require('./src/errorHandling/ErrorFallback')

// Shortcut to global styles
const style = document.documentElement.style

style.setProperty('--top-banner-height', 0)

const setTopBannerHeight = () => {
  const topBanner = document.querySelector('#top-banner')

  if (topBanner) {
    style.setProperty('--top-banner-height', Math.round(topBanner.offsetHeight * 100) / 100 + 'px')
  } else {
    style.setProperty('--top-banner-height', '0px')
  }
}

setTopBannerHeight()

// Keep track of various heights
const sizeListener = () => {
  style.setProperty('--window-height', window.innerHeight + 'px')

  style.setProperty('--layout-height', window.innerHeight + 'px');

  setTopBannerHeight()
}

sizeListener()
window.addEventListener('resize', sizeListener)

exports.wrapRootElement = ({ element }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <ContextProvider>{element}</ContextProvider>
  </ErrorBoundary>
)
